import React from 'react';
import Navbar from '../ui/Navbar';
import { Footer } from '../ui/Footer';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen bg-l-bg-1 dark:bg-d-bg-1">
      <div className="absolute top-0 left-0 right-0 z-20">
        <Navbar />
      </div>
      <main className="pb-0">{children}</main>
      <Footer />
    </div>
  );
};

export default Layout;
